import React from "react";
import { AuthContext } from "../context/AuthContext";

class ErrorBoundary extends React.Component {
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
      user: null,
      showDevDetails: false,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Get user info from context
    const user = this.context?.user || null;
    this.setState({ error, errorInfo, user });

    // Prepare error payload
    const errorPayload = {
      error: error?.toString(),
      errorInfo: errorInfo?.componentStack,
      user,
      url: window.location.href,
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent,
    };

    // Optionally, send errorPayload to a backend/email service here
    if (this.props.onError) {
      this.props.onError(error, errorInfo, errorPayload);
    }
  }

  handleToggleDevDetails = () => {
    this.setState((prev) => ({ showDevDetails: !prev.showDevDetails }));
  };

  render() {
    if (this.state.hasError) {
      const isDev = process.env.NODE_ENV === "development";
      const { showDevDetails, error, errorInfo } = this.state;
      return (
        this.props.fallback || (
          <div
            style={{
              padding: 32,
              textAlign: "center",
              maxWidth: 600,
              margin: "40px auto",
              background: "#fff",
              borderRadius: 12,
              boxShadow: "0 2px 16px #0001",
            }}
          >
            <svg
              width="48"
              height="48"
              fill="none"
              viewBox="0 0 24 24"
              style={{ marginBottom: 16 }}
            >
              <circle cx="12" cy="12" r="12" fill="#ffeaea" />
              <path
                d="M12 7v5m0 4h.01"
                stroke="#d32f2f"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <h2 style={{ color: "#d32f2f", marginBottom: 8 }}>
              Something went wrong
            </h2>
            <p style={{ color: "#444", marginBottom: 24 }}>
              We&apos;re sorry, but an unexpected error occurred.
              <br />
              Our team has been notified and is working to resolve the issue.
            </p>
            {isDev && (
              <div style={{ marginBottom: 16 }}>
                <button
                  onClick={this.handleToggleDevDetails}
                  style={{
                    background: "#eee",
                    color: "#333",
                    border: "none",
                    borderRadius: 4,
                    padding: "6px 16px",
                    cursor: "pointer",
                  }}
                >
                  {showDevDetails
                    ? "Show Production Error"
                    : "Show Developer Details"}
                </button>
              </div>
            )}
            {isDev && showDevDetails && (
              <div
                style={{
                  textAlign: "left",
                  background: "#f9f9f9",
                  border: "1px solid #eee",
                  borderRadius: 8,
                  padding: 16,
                  margin: "0 auto",
                  maxWidth: 520,
                  overflowX: "auto",
                }}
              >
                <h3 style={{ color: "#d32f2f" }}>Error Details</h3>
                <pre
                  style={{
                    color: "#b71c1c",
                    fontSize: 14,
                    whiteSpace: "pre-wrap",
                  }}
                >
                  {error && error.toString()}
                </pre>
                <pre
                  style={{
                    color: "#333",
                    fontSize: 13,
                    whiteSpace: "pre-wrap",
                  }}
                >
                  {errorInfo && errorInfo.componentStack}
                </pre>
              </div>
            )}
          </div>
        )
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
